<mat-card class="col-top">
  <mat-card-content>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
        <div class="container-icon">
          <span class="material-icons iconstyle">
            task_alt
          </span>
        </div>

        <div class="container-text">
          <span class="title" style="font-weight: 600; color: #4d4d4d; font-size: 1em;">
            ¡Simulación guardada con éxito!
          </span>
          <span class="sub-title" style="font-weight: 400; margin-top: 10px; display: block;">
            Ahora puedes descargar el archivo haciendo clic en el siguiente botón.
          </span>
        </div>

        <div class="container-btn">
          <button mat-flat-button color="primary" class="primary-button" [disabled]="enviandoBtn" (click)="downloadPdf()">
            <span *ngIf="!enviandoBtn">Descargar simulación</span>
            <span *ngIf="enviandoBtn"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
          </button>

          <button mat-flat-button color="primary" class="secondary-button" (click)="nuevaSimulacion()">
            Nueva simulación
          </button>
        </div>

      </div>
    </div>
  </mat-card-content>
</mat-card>